(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-faq"]) return;
  try {
    


$('.js-accordion-title').click(function(){

    $(this).parent().toggleClass('visible');

});


$('.js-tabs-button').click(function() {

    // Check for active
    $('.tabs__item').removeClass('active');
    $(this).parent().addClass('active');

    // Display active tab
    let currentTab = $(this).attr('href');
    $('.tabs__pane').hide();
    $(currentTab).show();


    return false;
});
  
  } catch(e) { console.error(e); }
})();
})();
